export class Answer {
  question: string;
  answer: any;
  questionText: string;
  answerText: string;
  visible = true;
}
